/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type XeroSignupContainer_viewer$ref = any;
export type XeroSignupContainer_QueryVariables = {||};
export type XeroSignupContainer_QueryResponse = {|
  +viewer: ?{|
    +id: string,
    +component: ?string,
    +$fragmentRefs: XeroSignupContainer_viewer$ref,
  |}
|};
export type XeroSignupContainer_Query = {|
  variables: XeroSignupContainer_QueryVariables,
  response: XeroSignupContainer_QueryResponse,
|};
*/


/*
query XeroSignupContainer_Query {
  viewer {
    id
    component(name: "signup_xero")
    ...XeroSignupContainer_viewer
  }
}

fragment XeroSignupContainer_viewer on Viewer {
  id
  actualPersonId
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "signup_xero"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"signup_xero\")"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "XeroSignupContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "XeroSignupContainer_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "XeroSignupContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actualPersonId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "XeroSignupContainer_Query",
    "operationKind": "query",
    "text": "query XeroSignupContainer_Query {\n  viewer {\n    id\n    component(name: \"signup_xero\")\n    ...XeroSignupContainer_viewer\n  }\n}\n\nfragment XeroSignupContainer_viewer on Viewer {\n  id\n  actualPersonId\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3a8b5d2acf34d7c7b4955c4718a85f53';

module.exports = node;
